export const toastifyClasses = {
  toastClassName: '!p-4',
  bodyClassName: '!text-xs !text-text-main !m-0 !p-0'
}
